import * as type from '@src/utils/type-utils';
import * as common from '@src/utils/common-util';

export default class ScriptModel {
  constructor({ condition = true, script, env, resolve, reject, prepare = common.noop, custom }) {
    this.condition = condition;
    this.script = script;
    /**
     * 当 env 存在时才有 normalize 的意义
     */
    this.env = env && ScriptModel.normalizeEnv(env);
    this.prepare = prepare;
    this.resolve = resolve;
    this.reject = reject;
    this.custom = custom;
  }

  static normalizeEnv(env) {
    return type.isArray(env) ? env : [env];
  }
}
